import { getServerDate } from "../utils/storage/date";
import { NODEVICEID } from "./DutyStatusLog";

export type TDriver = IIdEntity | "UnknownDriverId";

export interface IDriverChange {
    id?: string;
    version?: string;
    type: string;
    dateTime: string;
    device: IIdEntity | string;
    driver: TDriver;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    _syncCounter?: number;
}

export default class DriverChangeLog implements IDriverChange {

    id?: string;
    version?: string;
    type: string;
    dateTime: string;
    device: IIdEntity;
    driver: IIdEntity;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    _syncCounter: number;

    constructor(sourceObject?: IDriverChange) {
        if (sourceObject && Object.keys(sourceObject).length > 0) {
            this.id = sourceObject.id || undefined;
            this.type = sourceObject.type || "Driver";
            this.dateTime = sourceObject.dateTime || getServerDate().toISOString();
            this.device = sourceObject.device && typeof sourceObject.device !== "string" ? sourceObject.device : { id: NODEVICEID };
            this.driver = sourceObject.driver && typeof sourceObject.driver !== "string" ? sourceObject.driver : { id: "UnknownDriverId" };
            this.version = sourceObject.version || undefined;

            this._syncCounter = sourceObject._syncCounter || 5;
        } else {
            this.id = undefined;
            this.type = "Driver";
            this.dateTime = getServerDate().toISOString();
            this.device = { id: NODEVICEID };
            this.driver = { id: "UnknownDriverId" };

            this._syncCounter = 5; // Default value for sync retry
        }
    }
}